<template>
  <div id="app">
    <div class="header">
      <div class="header-img">
        <ul>
          <li>
            <img src="./assets/icon.png" />
          </li>
          <li style="margin-top: -4px;">
            <p class="title">蘑菇云</p>
            <p class="title" style="font-size:22px">mogume</p>
          </li>
        </ul>

      </div>
      <div class="header-con">
      </div>
      <div class="header-down">
        <ul v-if="isPc">
          <!-- <li class="pc">
              <a  @click="pc"><img src="./assets/pc-down.png" /></a>
            </li> -->
          <li class="ios" v-show="iosShow" @mouseenter="enterIos" @mouseleave="leaveIos">
            <img src="./assets/ios-h5.png" style="position: relative;top: -1px;" />
            <div class="versionBox" style="top: 0px;">
              <a>iOS下载</a>
              <!-- <span>版本{{ iosVersion }}</span> -->
            </div>
            <vue-qr v-show="iosImg" :logoSrc="imageUrl" :text="iosUrl" :size="150" class="v-img ios-qr"></vue-qr>
          </li>
          <li class="and" v-show="andShow" @click="mushroomcloud()" @mouseenter="enterAndroid" @mouseleave="leaveAndroid">
            <img src="./assets/and-h5.png" />
            <div class="versionBox">
              <a>安卓下载</a>
              <span>版本{{ andVersion }}</span>
            </div>
            <vue-qr v-show="andImg" :logoSrc="imageUrl" :text="andUrl" :size="150" class="v-img android-qr"></vue-qr>
          </li>
          <li class="web" @click="mogucloud()">
            <img src="./assets/web-h5.png" />
            <a style="margin-left: 8px;">网页版</a>

          </li>
          <li class="pc" @click="openDown()">
            <img src="./assets/windows.png" />
            <div class="versionBox">
              <a>PC版下载</a>
              <span>版本v0.3.10</span>
            </div>
          </li>
        </ul>
        <ul v-else>
          <!-- <li>
              <a @click="pc"><img src="./assets/pc-down.png" /></a>
            </li> -->
          <li v-show="iosShow" @click="ios()" style="display: inline-block;">
            <img src="./assets/ios-h5.png"  />
            <a style="margin-left: 8px;">iOS下载</a>
            <!-- <span>版本{{ iosVersion }}</span> -->
          </li>
          <li v-show="andShow" @click="mushroomcloud()">
            <img src="./assets/and-h5.png" /><a>安卓下载</a>
            <span>版本{{ andVersion }}</span>
          </li>
        </ul>
        <div class="qrcodes" ref="qrCodeUrlsIOS" v-show="iosDown">
          <!-- <img v-show="iosImg" src="./assets/ios-download.png" style="position: relative; top: 80px; left: -590px;" />
             <img v-show="andImg" src="./assets/and-download.png" style="position: relative; top: 80px; left: -380px;"/> -->
        </div>
        <div class="qrcodes" ref="qrCodeUrlsAnd" v-show="andDown"></div>
      </div>
    </div>

    <div class="main">
      <div class="desc">
        <div style="width: 100%">
          <p class="desc-title">核心功能</p>
        </div>
        <div class="desc-img">
          <div class="item select">
            <div class="box">
              <img src="./assets/con1.png" alt="">
              <p class="item-text">批量控制</p>
              <span>可批量操作云机重启/恢复出厂/安装/卸载</span>
            </div>
          </div>
          <div class="item">
            <div class="box">
              <img src="./assets/con2.png" alt="">
              <p class="item-text">应用管理</p>
              <span>支持95%以上应用安装</span>
            </div>

          </div>
          <div class="item">
            <div class="box">
              <img src="./assets/con3.png" alt="">
              <p class="item-text">集控部署</p>
              <span>实现全自动的设备和脚本管理</span>
            </div>

          </div>
          <div class="item">
            <div class="box">
              <img src="./assets/con4.png" alt="">
              <p class="item-text">不间断运行</p>
              <span>7*24小时全时在线，无惧断网断电，无流量限制</span>
            </div>

          </div>
          <div class="item">
            <div class="box">
              <img src="./assets/con5.png" alt="">
              <p class="item-text">XR框架安装</p>
              <span>让手机扩展无限可能</span>
            </div>

          </div>
          <div class="item">
            <div class="box">
              <img src="./assets/con6.png" alt="">
              <p class="item-text">同屏监控</p>
              <span>实时监控云手机状态</span>
            </div>

          </div>
        </div>
      </div>


      <div class="extendService" style="display:none">
        <p class="desc-title">扩展服务</p>

        <div class="content">
          <div class="boxs">
            <!-- <el-carousel :autoplay='false' @change='prevClick()' type="card" indicator-position="none" trigger="click" :interval="3000" arrow="always" style="width:90%">
                      <el-carousel-item v-for="item in imgList" :key="item.name">
                        <img :src="item.src"  />
                        <div style="position: relative;top: -242px;">
                          <p>{{item.name}}</p>
                          <span>{{item.title}}</span>
                        </div>
                         </el-carousel-item>
                   </el-carousel> -->
            <!-- <div class="swiper-container" style="height:300px;width:100%">
                 <div class="swiper-button-next"></div>
                  <div class="swiper-button-prev"></div>
                <div class="swiper-wrapper">

                  <div class="swiper-slide" v-for="item in imgList" :key="item.name" style="width:400px">
                     <img :src="item.src"  />
                        <div style="position: relative;left: -398px;top: -37px;">
                          <p>{{item.name}}</p>
                          <span>{{item.title}}</span>
                        </div>
                  </div>

                  </div>
                </div> -->
            <div class="swiper-wrap" style=" width: 1420px;margin: 0 auto;position: relative;">
              <div class="swiper-button-next "></div>
              <div class="swiper-button-prev "></div>
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="item in imgList" :key="item.name">
                    <img :src="item.src" />
                    <div style="position: relative;left: -18px;top:-246px;">
                      <p>{{ item.name }}</p>
                      <span>{{ item.title }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div>

              </div>
            </div>
          </div>
        </div>
        <div class="h5Contend">
          <ul>
            <!-- <li>
                 <p>虚拟定位</p>
                 <span>一键设置，修改云机实时定位。</span>
               </li> -->
            <li>
              <p>设备大师</p>
              <span>修改手机参数，一键设置，更换机型。</span>
            </li>
            <li>
              <p>IP代理</p>
              <span>静态IP、动态IP、专属IP。</span>
            </li>
            <li>
              <p>窗口多开服务</p>
              <span>控制窗口多开，可同时观察多台设备。</span>
            </li>
            <li>
              <p>多路实时直播</p>
              <span>多平台多账号直播方案，直播专用。</span>
            </li>
            <li :class="h5Hide ? 'h5Hide' : ''">
              <p>远程虚拟相机</p>
              <span>扫码，人脸识别高级验证工具。</span>
            </li>
            <li :class="h5Hide ? 'h5Hide' : ''">
              <p>日志调试</p>
              <span>一键输出云机进程日志。</span>
            </li>
            <li :class="h5Hide ? 'h5Hide' : ''">
              <p>高级调试ADB</p>
              <span>远程连接调试工具。</span>
            </li>
            <li :class="h5Hide ? 'h5Hide' : ''" style="background-image: none;">
              <p></p>
              <span></span>
            </li>
          </ul>
          <span class="but" @click="h5More();">{{ butName }}
            <img src="./assets/h5-down.png" ref="butDown" />
          </span>
        </div>
      </div>
    </div>
    <div class="search">
      <video width="100%" height="100%" muted autoplay="autoplay" loop="loop">
        <source src="./assets/video.mp4" type="video/mp4">
        <source src="movie.ogg" type="video/ogg">
        您的浏览器不支持Video标签。
      </video>
    </div>
    <div class="info">
      <p class="tit">公司简介</p>
      <p class="text">
        深圳充满科技有限公司，是一家依托 ARM 集群系统搭建智能云端应用虚拟化平台的科技公司。公司深耕云服务领域，运用互联网、数据处理、虚拟云等前沿技术，聚焦虚拟手机应用平台的研发与搭建，面向用户打造专业的虚拟化手机平台——“蘑菇云手机”。</p>
    </div>
    <div class="footer">
      <div class="footer-title">如何使用</div>
      <div class="footer-content">
        <div class="item">
          <div class="footer-register"></div>
          <p class="footer-text">注册云手机</p>
        </div>
        <div class="footer-jiantou"></div>
        <div class="item">
          <div class="footer-service"></div>
          <p class="footer-text">订购云手机和配套服务</p>
        </div>
        <div class="footer-jiantou"></div>
        <div class="item">
          <div class="footer-upload"></div>
          <p class="footer-text">上传应用和脚本</p>
        </div>
        <div class="footer-jiantou"></div>
        <div class="item">
          <div class="footer-phone"></div>
          <p class="footer-text">批量监控云手机</p>
        </div>
      </div>
      <div class="registered">
        <a @click="register()"><span>立即注册</span></a>
      </div>
    </div>
    <div class="bottom">
      <div v-if="isPc" class="pcBox">

        <p>
          <span>Copyright ©2021 蘑菇云 版权所有</span> &nbsp; &nbsp;
          <span>
            <a href="http://beian.miit.gov.cn/" target=_blank>粤ICP备2022092302号</a>
          </span>&nbsp; &nbsp;
          <span>
            <img src="../src/assets/police.png" style="vertical-align: middle;margin-top: -1px;" />
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009546" target=_blank>粤公网安备
              44030502009546号</a>
          </span> &nbsp; &nbsp;
          <span>增值电信业务经营许可证：粤B2-20221165</span>

          <a @click="permit()">| 隐私政策</a> <a @click='service()'>服务协议 |</a> &nbsp; &nbsp;
          <span>联系客服：574075437(QQ群)</span>
        </p>
        <p style="margin-top:7px">
          <span>开发者: 深圳充满科技有限公司 &nbsp; &nbsp;地址：深圳市南山区粤海街道高新区社区高新南九道53号航空航天大厦2号楼 &nbsp; &nbsp;电话：0755-86702680</span>
        </p>

      </div>

      <div v-else class="h5Box">
        <p>
          <span>Copyright ©2021 蘑菇云 版权所有</span>
          <a href="http://beian.miit.gov.cn/" target=_blank>粤ICP备2022092302号 </a>
        </p>
        <p>
          <img src="../src/assets/police.png" style="vertical-align: middle;margin-top: -1px;" />
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44030502009546" target=_blank>粤公网安备
            44030502009546号</a>
        </p>
        <p>
          <span>增值电信业务经营许可证：粤B2-20221165</span>
        </p>
        <p>

          <a @click="permit()">隐私政策</a> <a @click='service()'>服务协议</a>
          丨&nbsp;联系客服：721929620(QQ群)

        </p>
        <p>
          <span>开发者：深圳充满科技有限公司</span>
        </p>
        <span>地址：深圳市南山区粤海街道高新区社区高新南九道53号航空航天大厦2号楼 &nbsp; &nbsp;电话：0755-86702680 </span>
        <span></span>
      </div>

    </div>

  </div>
</template>

<script>
import QRCode from "qrcodejs2";
import vueQr from "vue-qr";
import Swiper from 'swiper';
export default {
  name: 'App',
  data() {
    return {
      iosDown: false,
      andDown: false,
      iosUrl: '',
      andUrl: '',
      imageUrl: require("./assets/icon.png"),
      showDownload: false,
      height: 0,
      isDownloadAndroid: false,
      isShowAndroid: false,
      h5Hide: true,
      butName: '查看更多',
      iosShow: true,
      andShow: true,
      isPc: true,
      imgList: [
        // {
        //   name: "虚拟定位",
        //   src: require("@/assets/s1.png"),
        //   title: "一键设置，修改云机实时定位。"
        // },
        {
          name: "设备大师",
          src: require("@/assets/s2.png"),
          title: "修改手机参数，一键设置，更换机型。"
        },
        {
          name: "IP代理",
          src: require("@/assets/s3.png"),
          title: "静态IP、动态IP、专属IP。"
        },
        {
          name: "窗口多开服务",
          src: require("@/assets/s4.png"),
          title: "控制窗口多开，可同时观察多台设备。"
        },
        {
          name: "多路实时直播",
          src: require("@/assets/s5.png"),
          title: "多平台多账号直播方案，直播专用。"
        },
        {
          name: "远程虚拟相机",
          src: require("@/assets/s6.png"),
          title: "扫码，人脸识别高级验证工具。"
        },
        {
          name: "日志调试",
          src: require("@/assets/s7.png"),
          title: "一键输出云机进程日志。"
        },
        {
          name: "高级调试ADB",
          src: require("@/assets/s8.png"),
          title: "远程连接调试工具。"
        }
      ],
      iosImg: false,
      andImg: false,
      url: 'http://www.mogume.com', //深圳机房
      andVersion: '',
      iosVersion: '',
    }
  },
  mounted() {
    this.isShow();
    window.addEventListener('scroll', this.handleScroll);
    new Swiper('.swiper-container', {
      slidesPerView: 3,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: true,
      loopFillGroupWithBlank: true,
      pagination: '.swiper-pagination',
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
    });
  },
  components: {
    vueQr,
  },
  methods: {
    ios() {
      if (this.isWeixinBrowserFun()) {
        this.$message({
          message: '请在浏览器中打开下载',
          type: "warning",
        });
        return
      } else {
        window.open(this.iosUrl, '_blank');
      }
    },
    pc() {
      window.location.href = `${this.url}/static/Install.exe`;
    },
    /**
   * 判断是否为微信浏览器
   */
    isWeixinBrowserFun() {
      let ua = navigator.userAgent.toLowerCase();
      return this.isWeixinBrowser = /micromessenger/.test(ua) ? true : false;
    },
    mogucloud() {
      window.open(`http://web.mogume.com`, '_blank');
      //  window.open(`http://10.0.0.92/mogucloud/#/`,'_blank');
    },
    mushroomcloud() {
      if (this.isWeixinBrowserFun()) {
        this.$message({
          message: '请在浏览器中打开下载',
          type: "warning",
        });
        return
      } else {
        // window.location.href= `${this.url}/static/mushroomcloud.apk`;
        window.location.href = this.andUrl;
      }

    },
    register() {
      if (!this.isMobile()) {
        window.open(`http://web.mogume.com/#/register?type=1`, '_blank');
      } else {
        window.open(`${this.url}/mogucloudh5/#/register?type=1`, '_blank');
      }
    },
    permit() {
      window.location.href = `${this.url}/static/permit.html`
    },
    service() {
      window.location.href = `${this.url}/static/service.html`
    },
    enterAndroid() {
      this.isDownloadAndroid = true;
      this.andImg = true;
    },
    leaveAndroid() {
      this.isDownloadAndroid = false;
      this.andImg = false;
    },
    enterIos() {
      this.isDownloadAndroid = true;
      this.iosImg = true;
    },
    leaveIos() {
      this.isDownloadAndroid = false;
      this.iosImg = false;
    },

    backTop() {
      scrollTo(0, 0)
    },
    handleScroll() {
      if (!this.isMobile()) {
        this.height = document.documentElement.clientHeight / 2;
        if (document.documentElement.scrollTop > document.documentElement.clientHeight / 2) {
          this.showDownload = true;
          document.querySelector('.desc-img').style.opacity = 1;
          document.querySelector('.desc-img').style.transform = 'translateX(0) translateY(0)';
        } else {
          this.showDownload = false;
          document.querySelector('.desc-img').style.opacity = 0;
          document.querySelector('.desc-img').style.transform = 'transform 1s,opacity 1s';
          document.querySelector('.desc-img').style.transform = 'translateX(0) translateY(100px)';
        }
      } else {
        document.querySelector('.desc-img').style.opacity = 1;
        document.querySelector('.desc-img').style.transform = 'translateX(0) translateY(0)';
      }


    },
    h5More() {
      this.h5Hide = !this.h5Hide;
      if (!this.h5Hide) {
        this.butName = '收起'
        this.$refs.butDown.style.transform = "rotate(180deg)";
      } else {
        this.butName = '查看更多'
        this.$refs.butDown.style.transform = "rotate(0deg)";
      }
    },
    appSource() {
      const u = navigator.userAgent;
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (isiOS) {
        return "ios";
      } else {
        return "andriod";
      }
    },
    isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;

    },
    isShow() {
      if (this.isMobile()) {
        this.isPc = false;
        this.versionFunction()
        console.log("移动端");
        if (this.appSource() == 'ios') {
          this.iosShow = true;
          this.andShow = false;
        } else if (this.appSource() == 'andriod') {
          this.iosShow = false;
          this.andShow = true;
        }
      } else {
        this.isPc = true;
        console.log("pc端");
        this.iosShow = true;
        this.andShow = true;
        this.versionFunction()


      }
    },
    prevClick() {
      console.log(document.querySelector('.el-carousel__item'));
      //  document.querySelector('.el-carousel__item').style.transform ='scale(1,1)'
    },

    /**
     * 获取版本信息
     */
    versionFunction() {
      var httpRequest = new XMLHttpRequest();//第一步：建立所需的对象
      httpRequest.open('GET','https://api.mogume.com/web/version', true);//第二步：打开连接  将请求参数写在url中
      // httpRequest.open('GET', 'http://10.0.1.34:7002/web/version', true);//第二步：打开连接  将请求参数写在url中

      httpRequest.setRequestHeader("Product-ID", "1001");
      httpRequest.setRequestHeader("Platform", "Web");
      httpRequest.send();//第三步：发送请求  将请求参数写在URL中
      httpRequest.onreadystatechange = () => {
        if (httpRequest.readyState == 4 && httpRequest.status == 200) {
          var json = httpRequest.responseText;//获取到json字符串，还需解析
          let obj = JSON.parse(json)
          /**
           * Android版本信息
           */
          this.andVersion = obj.result_data.android.version;
          this.andUrl = obj.result_data.android.download_url;

          /**
           * IOS版本信息
           */
          // this.iosVersion = obj.result_data.ios.version;
          this.iosUrl = 'https://www.mogume.com/h5/#/login'// obj.result_data.ios.download_url;

          // var json = httpRequest.responseText;//获取到json字符串，还需解析
          // let obj = JSON.parse(json)
          // this.andVersion = (obj.result_data.version).substring(0, 3);
          // this.andUrl = obj.result_data.download_url;
          // var qrcode = new QRCode(this.$refs.qrCodeUrlsAnd, {
          //   text: this.andUrl, // 需要转换为二维码的内容
          //   width: 150,
          //   height: 150,
          //   colorDark: '#000000',
          //   colorLight: '#ffffff',
          //   correctLevel: QRCode.CorrectLevel.H
          // })
        }
      };
    },
    /**
     * 下载exe
     */
    openDown(){
      window.location.href = `https://client.mogume.com/%E8%98%91%E8%8F%87%E4%BA%91%E6%89%8B%E6%9C%BA-v0.3.10-setup.exe`
    }

  },


}
</script>
<style  scoped>
@import "app";

.qrcodes {
  display: inline-block;
  width: 150px;
  height: 150px;
  background-color: #fff;
  padding: 2px;
  box-sizing: border-box;
}

.header-down li .v-img {
  position: absolute;
  display: block;
  width: 150px;
  min-width: 150px;
  height: 150px;
  top: 70px;
  left: 50%;
  transform: translateX(-50%);
  opacity: 1;
  z-index: 10;
}

.header-down > ul > li {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/App.vue